import React, { useState, useEffect, useRef } from "react";
import "../App.css";
import { useHistory, useLocation } from "react-router-dom";
import { Form, FormGroup, Button, Input } from "reactstrap";
import MyLoader from "./util/loader";
import MyError from "./util/error";
import MyStorage from "./util/storage";
import Api from "./api/api";
import showToast from "./util/toast";
import { ToastContainer } from "react-toastify";
import CustomPicker from "./util/custom_picker";
import MyMultiPicker from "./util/multi_picker";
import "react-dropdown-tree-select/dist/styles.css";

const AddProgram = () => {
  const history = useHistory();
  const location = useLocation();
  let filePath = MyStorage.getFileUrls().SpecialProgram;

  const model = location.state.model;

  const [editMode, setEditMode] = useState(model != null);
  const [showError, setShowError] = useState(false);
  const [error, setError] = useState("");
  const [loader, setLoader] = useState(false);

  let url = editMode ? filePath + model.image : null;
  console.log("image: " + url);

  const [mainShot, setMainShot] = useState(null);
  const [mainShotUrl, setMainShotUrl] = useState(url);
  const addMainShot = useRef(null);

  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");
  const [price, setPrice] = useState("");
  const [inappId, setInappId] = useState("");
  const [expiry, setExpiry] = useState("");
  const [ages, setAges] = useState([]);
  const [goals, setGoals] = useState([]);
  const [age, setAge] = useState("1"); // id
  const [goal, setGoal] = useState("1"); // id

  const [selectedVideos, setSelectedVideos] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedPrograms, setSelectedPrograms] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    // load filters
    Api.getFilters(
      (response) => {
        setAges(response.ages);
        setGoals(response.goals);
      },
      (error) => {}
    );
    if (editMode) {
      setTitle(model.title);
      setDetail(model.detail);
      setPrice(model.price);
      setInappId(model.inapp_id == null ? "" : model.inapp_id);
      setExpiry(model.non_member_expiry === 0 ? "" : model.non_member_expiry);
      setAge(model.age);
      setGoal(model.goal);
      Api.getSpecialProgramDetails(
        model.id,
        (response) => {
          if (response.status === "success") {
            const programDetails = response.data;
            const videoLinks = programDetails.videoLinks;
            const sectionLinks = programDetails.sectionLinks;
            const programLinks = programDetails.programLinks;
            // format videos
            let videos = [];
            for (let i = 0; i < videoLinks.length; i++) {
              const v = videoLinks[i];
              videos = videos.concat({
                id: v.video.id,
                title: v.video.title,
              });
            }
            // format sections
            let sections = [];
            for (let i = 0; i < sectionLinks.length; i++) {
              const c = sectionLinks[i];
              sections = sections.concat({
                id: c.category.id,
                title: c.category.title,
              });
            }
            // format programs
            let programs = [];
            for (let i = 0; i < programLinks.length; i++) {
              const p = programLinks[i];
              programs = programs.concat({
                id: p.special_program.id,
                title: p.special_program.title,
              });
            }

            console.log("api selectedVideos: " + JSON.stringify(videos));

            setSelectedVideos(videos);
            setSelectedCategories(sections);
            setSelectedPrograms(programs);
          }
        },
        (error) => {
          //
        }
      );
    } else {
      setSelectedVideos([]);
      setSelectedPrograms([]);
    }
  };

  const formatSelectedVideos = () => {
    if (selectedVideos == null) return [];
    console.log("selectedVideos: " + selectedVideos.length);
    let videos = [];
    for (let i = 0; i < selectedVideos.length; i++) {
      const video = selectedVideos[i];
      videos = videos.concat({
        video_id: video.id,
        title: video.title,
      });
    }
    return videos;
  };

  const formatSelectedSections = () => {
    console.log("selectedCategories: " + selectedCategories.length);
    let sections = [];
    for (let i = 0; i < selectedCategories.length; i++) {
      const c = selectedCategories[i];
      sections = sections.concat({
        cat_id: c.id,
        title: c.title,
      });
    }
    return sections;
  };

  const formatSelectedPrograms = () => {
    if (selectedPrograms == null) return [];
    let programs = [];
    for (let i = 0; i < selectedPrograms.length; i++) {
      const p = selectedPrograms[i];
      programs = programs.concat({
        other_pid: p.id,
        title: p.title,
      });
    }
    return programs;
  };

  const saveProgram = () => {
    console.log("saveProgram");
    if (!editMode && mainShot == null) {
      showToast("error", "Please choose image!");
      return;
    }
    if (title === "" || detail === "" || price === "") {
      setShowError(true);
      setError("Email empty!");
      return;
    }
    if ("" + price !== "0" && inappId === "") {
      setShowError(true);
      setError("Product Id cannot be empty for paid program!");
      return;
    }
    let videos = formatSelectedVideos();
    let sections = formatSelectedSections();
    let programs = formatSelectedPrograms();
    if (videos.length == 0 && programs.length == 0) {
      setShowError(true);
      setError("Please fill complete form!");
      return;
    }
    setShowError(false);
    setError("");
    setLoader(true);
    if (!editMode) {
      Api.addSpecialProgram(
        mainShot,
        price,
        age,
        goal,
        title,
        detail,
        inappId,
        expiry,
        JSON.stringify(videos),
        JSON.stringify(sections),
        JSON.stringify(programs),
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Program added!");
            history.goBack();
          }
        },
        (error) => {
          setLoader(false);
          setShowError(true);
          setError("Request Failed!");
        }
      );
    } else {
      Api.updateSpecialProgram(
        mainShot,
        model.id,
        price,
        age,
        goal,
        title,
        detail,
        inappId,
        expiry,
        JSON.stringify(videos),
        JSON.stringify(sections),
        JSON.stringify(programs),
        (response) => {
          setLoader(false);
          if (response.status === "success") {
            showToast("success", "Program updated!");
            history.goBack();
          }
        },
        (error) => {
          setLoader(false);
          setShowError(true);
          setError("Request Failed!");
        }
      );
    }
  };

  const showSelectedVideos = () => {
    if (selectedVideos == null) return "Choose Video(s)";
    let videos = "";
    for (let i = 0; i < selectedVideos.length; i++) {
      const vid = selectedVideos[i];
      if (i < selectedVideos.length - 1) videos = videos + vid.title + ",";
      else videos = videos + vid.title;
    }
    if (videos === "") return "Choose Video(s)";
    return videos;
  };

  const showSelectedCategories = () => {
    let cats = "";
    for (let i = 0; i < selectedCategories.length; i++) {
      const cat = selectedCategories[i];
      if (i < selectedCategories.length - 1) cats = cats + cat.title + ",";
      else cats = cats + cat.title;
    }
    if (cats === "") return "Choose Category(s)";
    return cats;
  };

  const showSelectedPrograms = () => {
    if (selectedPrograms == null) return "Choose Program(s)";
    let programs = "";
    for (let i = 0; i < selectedPrograms.length; i++) {
      const p = selectedPrograms[i];
      if (i < selectedPrograms.length - 1) programs = programs + p.title + ",";
      else programs = programs + p.title;
    }
    if (programs === "") return "Choose Program(s)";
    return programs;
  };

  return (
    <div className="main">
      <div
        className="titlebar"
        style={{ backgroundColor: "#f2f2f2", padding: 10, margin: -15 }}
      >
        <div style={{ color: "blue" }}>
          {editMode ? "Edit" : "Add"} Special Program
        </div>
      </div>
      <div
        style={{
          marginTop: 30,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Form
          className="form"
          style={{ width: 600, backgroundColor: "#f2f2f2" }}
        >
          <img
            src={mainShotUrl}
            style={{
              width: 150,
              height: 150,
              marginBottom: 5,
              marginTop: 0,
              objectFit: "contain",
              alignSelf: "center",
              backgroundColor: "white",
            }}
          />
          <Button
            style={{
              marginTop: 0,
              fontSize: 16,
              width: 150,
              alignSelf: "center",
              marginBottom: 15,
            }}
            className="btn-block"
            onClick={() => {
              addMainShot.current.click();
            }}
          >
            Choose Image
          </Button>
          <input
            type="file"
            style={{ display: "none" }}
            ref={addMainShot}
            onChange={(event) => {
              setMainShot(event.target.files[0]);
              setMainShotUrl(URL.createObjectURL(event.target.files[0]));
            }}
          />

          <FormGroup>
            <Input
              type="text"
              placeholder="Enter Program Name"
              value={title}
              onChange={(event) => {
                setTitle(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <Input
              type="textarea"
              placeholder="Enter Program Detail"
              value={detail}
              onChange={(event) => {
                setDetail(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Enter Price (0 means FREE)</div>
            <Input
              type="number"
              placeholder=""
              value={price}
              onChange={(event) => {
                setPrice(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Apple/Google Product ID</div>
            <Input
              type="text"
              placeholder=""
              value={inappId}
              onChange={(event) => {
                setInappId(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Expiry Days for Non-Subscriber</div>
            <Input
              type="number"
              placeholder=""
              value={expiry}
              onChange={(event) => {
                setExpiry(event.target.value);
              }}
            />
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Age Range</div>
            <select
              name="age"
              id="age"
              value={age}
              style={{ alignSelf: "center", display: "flex", width: 200 }}
              onChange={(event) => {
                setAge(event.target.value);
              }}
            >
              {ages.map((age, index) => {
                return <option value={age.id}>{age.title}</option>;
              })}
            </select>
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Goal</div>
            <select
              name="goal"
              id="goal"
              value={goal}
              style={{ alignSelf: "center", display: "flex", width: 200 }}
              onChange={(event) => {
                setGoal(event.target.value);
              }}
            >
              {goals.map((goal, index) => {
                return <option value={goal.id}>{goal.title}</option>;
              })}
            </select>
          </FormGroup>
          <FormGroup style={{ marginTop: 10 }}>
            <div>Videos</div>
            {selectedVideos == null ? null : (
              <CustomPicker
                library_type="special"
                type="video"
                title={"Select Videos"}
                selectedVideos={selectedVideos}
                onDone={(videos) => {
                  console.log("selected: " + JSON.stringify(videos));
                  setSelectedVideos(videos);
                }}
                button={
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: 10,
                      marginTop: 5,
                      backgroundColor: "white",
                      border: "1px solid lightgray",
                      borderRadius: 5,
                      borderColor: "lightgray",
                    }}
                  >
                    <div
                      style={{ alignSelf: "center", color: "gray", padding: 5 }}
                    >
                      {showSelectedVideos()}
                    </div>
                  </div>
                }
              />
            )}
          </FormGroup>
          {/* <FormGroup style={{ marginTop: 10 }}>
                        <div>Categories (Sections)</div>
                        <CustomPicker
                            type='category'
                            selectedCategories={selectedCategories}
                            title={'Select Categories'}
                            onDone={(categories) => {
                                console.log('selected categories: ' + JSON.stringify(categories));
                                setSelectedCategories(categories)
                            }}
                            button={
                                <div
                                    style={{ display: 'flex', paddingLeft: 10, marginTop: 5, backgroundColor: 'white', border: '1px solid lightgray', borderRadius: 5, borderColor: 'lightgray' }}>
                                    <div style={{ alignSelf: 'center', color: 'gray', padding: 5 }}>
                                        {showSelectedCategories()}
                                    </div>
                                </div>
                            } />
                    </FormGroup> */}
          <FormGroup style={{ marginTop: 10 }}>
            <div>Special Programs (Other)</div>
            {selectedPrograms == null ? null : (
              <MyMultiPicker
                title={"Select Sub Programs"}
                selectedPrograms={selectedPrograms}
                onDone={(programs) => {
                  console.log("selected: " + JSON.stringify(programs));
                  setSelectedPrograms(programs);
                }}
                button={
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: 10,
                      marginTop: 5,
                      backgroundColor: "white",
                      border: "1px solid lightgray",
                      borderRadius: 5,
                      borderColor: "lightgray",
                    }}
                  >
                    <div
                      style={{ alignSelf: "center", color: "gray", padding: 5 }}
                    >
                      {showSelectedPrograms()}
                    </div>
                  </div>
                }
              />
            )}
          </FormGroup>
          <MyError showError={showError} error={error} />
          <FormGroup style={{ marginTop: 10 }}>
            <Button
              className="btn-block"
              style={{ width: "100%", fontSize: 16 }}
              onClick={() => {
                console.log("click");
                saveProgram();
              }}
            >
              Save Program
            </Button>
          </FormGroup>
        </Form>
      </div>
      <MyLoader loader={loader} />
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default AddProgram;
